if (!customElements.get('cookie-preferences')) {
  customElements.define('cookie-preferences', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.message = this.querySelector('[role="status"]');
      this.onClick ||= this.openPreferences.bind(this);
      this.button?.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
    }

    async openPreferences() {
      if (this.button.disabled) return;
      this.button.disabled = true;
      this.message.hidden = true;
      try {
        // The native banner is injected by Shopify. Allow its async load to finish.
        for (let attempt = 0; !window.privacyBanner?.showPreferences && attempt < 50; attempt += 1) {
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
        if (!window.privacyBanner?.showPreferences) throw new Error('Cookie preferences unavailable');
        await window.privacyBanner.showPreferences();
      } catch {
        this.message.hidden = false;
      } finally {
        this.button.disabled = false;
      }
    }
  });
}
